import React, { useEffect } from 'react'
import AuthLayout from '../../../layout/AuthLayout'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../store/dataRoute'

const Setting = () => {
  const dispatch = useDispatch()

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Setting',
      route: null
    }
  ]

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  return (
    <AuthLayout>
      <div>ini halaman Setting</div>
    </AuthLayout>
  )
}

export default Setting